module.exports = __webpack_public_path__ + "media/images/static/top/local/photo4_mobile-9ad7dc8d4e0c64a4e1b01d3c0d36ee48.png";